import { render, staticRenderFns } from "./ContractorRegistractionModal.vue?vue&type=template&id=a87d1620&scoped=true&"
import script from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"
export * from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d1620",
  null
  
)

export default component.exports